import React, { useMemo } from 'react';
import { useBookContext } from '../../BookContext';
import { Link, useSearchParams } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import config from '../../../../../common-sk-doc/src/config';

const MyLittleFunBookChapterDetailView: React.FC<{ chapterId: string }> = ({
  chapterId,
}) => {
  const { book } = useBookContext();
  const chapter = useMemo(() => book.chapters.find((c) => c.id === chapterId), [
    book,
    chapterId,
  ]);

  const [searchParams, setSearchParams] = useSearchParams();
  const games = useMemo(() => {
    return chapter.lessons
      .map((l) => l.sections)
      .reduce((a, b) => a.concat(b), [])
      .map((s) => s.sectionGames)
      .reduce((a, b) => a.concat(b), []);
  }, [chapter]);
  const handleGoBack = () => {
    searchParams.delete('chapter');
    setSearchParams(searchParams);
  };

  return (
    <div className="chapter-view-detail position-relative book-my-little-fun-frame">
      <div className="position-relative chapter-view-detail-header">
        <div className="back-button" onClick={handleGoBack}>
          <SVG src={config.ASSETS_PATH + '/icons/home-btn.svg'} />
        </div>
        <div className={`chapter-header chapter-header-${chapterId}`} />
      </div>
      <div className="list-game">
        {games.map((game, i) => (
          <Link
            to={`/game/${game.id}`}
            className="game-name"
            onClick={(e) => {
              // if (!isShowGame) {
              //   e.preventDefault();
              //   handleShowNotificationModal();
              // }
              // if (window.electronAPI && !navigator.onLine) {
              //   e.preventDefault();
              //   window.electronAPI.openGame(game.link).then();
              // }
            }}
            rel="noopener noreferrer">
            <div key={i} className={`box-game game-${game.id} game-${i}`}>
              <div className="game-info">
                <div className="game-number">{i + 1}</div>
                <div className="game-name">{game.name}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
export default MyLittleFunBookChapterDetailView;
